import { isEqual } from 'lodash/fp';

import { PAGE_SIZE_OPTION_1 } from 'dashboard/lib/constants/pagination';
import { WorkflowVersion } from 'dashboard/models/workflow-version';
import {
  WorkflowVersionsActions,
  WorkflowVersionsActionType,
  WorkflowVersionsFilterParams,
} from 'dashboard/redux/actions/workflow-versions';
import { PaginationParams } from 'lib/interfaces/api';

export type WorkflowVersions = Record<string, WorkflowVersion[]>;

// N.B. Since this reducer is used for a simplified version history on the workflows page
// we don't need a lot of the boilerplate from `TableState` and `BaseFilterParams`
export interface WorkflowVersionsState {
  workflowVersions: WorkflowVersion[];
  paginationParams: PaginationParams;
  pageSize: number;
  currentPage: number;
  filters: WorkflowVersionsFilterParams;
}

export const initialState: WorkflowVersionsState = {
  workflowVersions: [],
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  paginationParams: undefined,
  filters: {
    workflowIds: [],
  },
  pageSize: PAGE_SIZE_OPTION_1,
  currentPage: 1,
};

export default (state: WorkflowVersionsState = initialState, action: WorkflowVersionsActions) => {
  switch (action.type) {
    case WorkflowVersionsActionType.SetWorkflowVersions: {
      const versionsList = Object.values<WorkflowVersion>(
        [...state.workflowVersions, ...action.payload.workflowVersions].reduce((acc, version) => {
          return {
            ...acc,
            [version.id]: version,
          };
        }, {}),
      ).sort((a, b) => {
        const aTime = new Date(a.attributes['created-at']).getTime();
        const bTime = new Date(b.attributes['created-at']).getTime();
        return bTime - aTime;
      });
      return {
        ...state,
        workflowVersions: versionsList,
        paginationParams: action.payload.paginationParams,
      };
    }

    case WorkflowVersionsActionType.ClearWorkflowVersions: {
      return initialState;
    }

    case WorkflowVersionsActionType.SetWorkflowVersionFilters: {
      const newFilters = {
        ...state.filters,
        ...action.payload.filters,
      };

      if (isEqual(newFilters, state.filters)) {
        return state;
      } else {
        return {
          ...state,
          filters: newFilters,
        };
      }
    }

    case WorkflowVersionsActionType.SetPageSize: {
      return {
        ...state,
        pageSize: action.payload.pageSize,
      };
    }

    case WorkflowVersionsActionType.SetCurrentPage: {
      return {
        ...state,
        currentPage: action.payload.currentPage,
      };
    }

    default:
      return state;
  }
};
